import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { I18N } from 'commons'

const TopErrorBox = ({ isSubmitting, errors, outerStyle, innerStyle }) => {
  const [errorMessages, setErrorMessages] = useState([])
  const Container = useRef(null)

  useEffect(() => {
    if (!isSubmitting || (isSubmitting && errors.location)) {
      let temp = []
      Object.keys(errors).forEach((name) => {
        if (errors[name]) {
          temp.push(errors[name])
        }
      })

      setErrorMessages(temp)
      if (temp.length > 0) {
        Container && Container.current && Container.current.focus()
      }
    }
  }, [isSubmitting])
  return (
    <div className={outerStyle ? outerStyle : 'row'} tabIndex="-1" ref={Container}>
      <div className={innerStyle ? innerStyle : 'col-md-8 mb-3'}>
        {!!errorMessages.length && (
          <div className="error-container">
            <p className="mb-1">
              <I18N>form.error.messages.group.title</I18N>
            </p>
            <ul>
              {Object.keys(errorMessages).map((name) => (
                <li key={name}>
                  <I18N>{errorMessages[name] ? errorMessages[name] : ''}</I18N>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

TopErrorBox.propTypes = {}

export default TopErrorBox
